import { QuestionData } from 'hooks/activities/useQueryActivityAssignments';
import { QuestionType, UpdateQuestionChoiceInput } from '__generated__/graphql';
import {
  IndexedValidationError,
  ValidationError,
} from 'components/ValidationErrors/ValidationErrors';
import { CreateQuestionInterface } from 'pages/Activities/activities.context';

export function validateQuestionChoices(
  choices: UpdateQuestionChoiceInput[]
): IndexedValidationError[] {
  const errors: IndexedValidationError[] = [];

  choices.forEach((choice, index) => {
    // Check for duplicate value.
    const duplicate = choices.find(
      (x, xIndex) =>
        xIndex !== index &&
        x.value?.trim() === choice.value?.trim() &&
        choice.value?.trim().length > 0
    );

    if (duplicate) {
      errors.push({
        index,
        severity: 'warning',
        message: 'Response options must be unique',
        code: 'duplicate',
      });
    }
  });

  return errors;
}

export default function validateQuestion(question: CreateQuestionInterface): ValidationError[] {
  const errors: ValidationError[] = [];

  if (question.type === QuestionType.Choice) {
    // Verify choices is not empty.
    const options = question.questionChoices ?? [];
    if (!options.length) {
      errors.push({
        severity: 'warning',
        message: 'Choice question must have response options set',
        code: 'required',
      });
    } else if (question.isMultiple && options.length < 2) {
      // If multiple choice, must have at least 2 options.
      errors.push({
        severity: 'warning',
        message: 'Multiple choice question must have at least 2 response options',
        code: 'min',
      });
    }

    const invalidOptions = options.filter(
      (option) => option.label == null || option.label.trim().length === 0
    );
    if (invalidOptions.length) {
      errors.push({
        severity: 'warning',
        message: 'One or more options are missing a label',
        code: 'required',
      });
    }

    // Prevent duplicates.
    const choicesErrors = validateQuestionChoices(options);
    choicesErrors.length && errors.push(...choicesErrors);
  }

  return errors;
}
